<div class="px-2 py-2.5 mr-4">
  <a
    [link]="linkUrl"
    class="font-accent font-bold text-17px text-white"
    >{{ label }}</a
  >
</div>
